import { SWRConfig } from 'swr';
import { jsx as _jsx } from "react/jsx-runtime";
var swrConfig = {
  errorRetryCount: 3,
  errorRetryInterval: 10000,
  focusThrottleInterval: 300000,
  shouldRetryOnError: true,
  suspense: false,
  /* eslint-disable max-params -- library requires too many parameters */
  onErrorRetry: function onErrorRetry(error, key, config, revalidate, _ref) {
    var _error$response$statu, _error$response, _config$errorRetryCou;
    var retryCount = _ref.retryCount;
    var statusCode = (_error$response$statu = (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) !== null && _error$response$statu !== void 0 ? _error$response$statu : 200;
    if (statusCode >= 400 && statusCode < 500) {
      return;
    }
    var rCount = retryCount !== null && retryCount !== void 0 ? retryCount : 1;
    if (rCount >= ((_config$errorRetryCou = config.errorRetryCount) !== null && _config$errorRetryCou !== void 0 ? _config$errorRetryCou : 0)) {
      return;
    }
    setTimeout(function () {
      revalidate({
        retryCount: rCount
      });
    }, config.errorRetryInterval);
  }
  /* eslint-enable max-params */
};

export var ApiProvider = function ApiProvider(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/_jsx(SWRConfig, {
    value: swrConfig,
    children: children
  });
};